"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Algorithm = void 0;
let Algorithm = exports.Algorithm = /*#__PURE__*/function (Algorithm) {
  Algorithm["Ensemble"] = "Ensemble";
  Algorithm["ExponentialSmoothing"] = "ExponentialSmoothing";
  Algorithm["Sarima"] = "Sarima";
  Algorithm["FBProphet"] = "FBProphet";
  Algorithm["Regression"] = "Regression";
  return Algorithm;
}({});
var _default = (generator, {
  integration,
  visor
}) => generator({
  getData: (data, showDiagnostics) => ({
    baseURL: visor,
    method: 'post',
    url: `widget/data`,
    data,
    ...(showDiagnostics && {
      config: {
        headers: {
          'X-Fetch-TadaMetrics': true
        }
      }
    }),
    returnBody: false
  }),
  getData2: data => ({
    baseURL: visor,
    method: 'post',
    url: `widget/widgetdata`,
    data,
    then: body => body.map(series => ({
      ...series,
      ...(!series.data && {
        data: []
      })
    }))
  }),
  export: data => ({
    baseURL: visor,
    method: 'post',
    url: `widget/export`,
    data
  }),
  getFormData: data => ({
    baseURL: visor,
    method: 'post',
    url: `widget/form`,
    data
  }),
  save: (visorId, application, data) => ({
    baseURL: integration,
    method: 'post',
    url: 'widgets',
    config: {
      params: {
        modelServiceName: application,
        visorId
      }
    },
    data
  }),
  forecast: data => ({
    baseURL: integration,
    method: 'post',
    url: `/statistics/forecast`,
    data
  }),
  forecastSave: data => ({
    baseURL: integration,
    method: 'post',
    url: `/statistics/forecastnsave`,
    data
  }),
  getGTMTransactionNodes: (visorId, modelname, widgetId) => ({
    baseURL: integration,
    method: 'get',
    url: 'widgets/TransactionNodes',
    config: {
      params: {
        modelname,
        visorId,
        widgetId
      }
    }
  }),
  getGTMDataByTransactionNode: (modelname, nodeId, data) => ({
    baseURL: integration,
    method: 'post',
    url: 'GTM/Data',
    config: {
      params: {
        appref: modelname,
        id: nodeId
      }
    },
    data
  })
});
exports.default = _default;